var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 21.7,
    viewBox: "0 0 21.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    d: "M10-.85A10.85,10.85,0,0,1,20.85,10,10.85,10.85,0,0,1,10,20.85,10.85,10.85,0,0,1-.85,10,10.85,10.85,0,0,1,10-.85Zm0,20A9.15,9.15,0,1,0,.85,10,9.16,9.16,0,0,0,10,19.15Z",
    transform: "translate(2 2)",
    fill: "#00246A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M12,16.85a6.243,6.243,0,0,1-4.68-2.34.85.85,0,0,1,1.358-1.023A4.584,4.584,0,0,0,12,15.15a4.586,4.586,0,0,0,3.322-1.663A.85.85,0,1,1,16.68,14.51,6.243,6.243,0,0,1,12,16.85Z",
    fill: "#00246A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M9.01,9.85H9a.85.85,0,0,1,0-1.7h.01a.85.85,0,0,1,0,1.7Z",
    fill: "#00246A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M15.01,9.85H15a.85.85,0,0,1,0-1.7h.01a.85.85,0,0,1,0,1.7Z",
    fill: "#00246A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileSms);
export default __webpack_public_path__ + "static/media/smileSMS.fb14f077d2fa4f046acad24dec6a68b8.svg";
export { ForwardRef as ReactComponent };